exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-skeleton-loader{border-radius:4px;position:relative;vertical-align:top}@keyframes loading{to{-webkit-transform:translateX(100%);transform:translateX(100%)}}", ""]);

// exports
